import React from 'react';

import { useDeviceTypes } from '@travel/traveler-core/hooks';

import InternalLinksPcData from './InternalLinksPcData';
import InternalLinksSpData from './InternalLinksSpData';

import type { InternalLink } from 'HotelList-Types';
export type Props = {
  data: Array<InternalLink>;
  heading: string;
};

const InternalLinksCard = (props: Props) => {
  const { isPC } = useDeviceTypes();
  const { heading, data } = props;

  return (
    <>
      {isPC ? (
        <InternalLinksPcData heading={heading} data={data} />
      ) : (
        <InternalLinksSpData data={data} heading={heading} />
      )}
    </>
  );
};

export default InternalLinksCard;
